import api from "../../Services/api";
import UserDefault from "../images/user.png";

// Map com { rm: { data: base64, expires: timestamp } }
export const imageCache = new Map();

// Duração do cache (em ms) → 50 minutos
const CACHE_DURATION = 50 * 60 * 1000;

export default async function Url_Image(RM, thumb = false) {
  // thumb padrão é false
  // Cria chave única para cache baseada no RM + tipo de imagem
  const cacheKey = `${RM}_${thumb ? "thumb" : "original"}`;
  const cacheItem = imageCache.get(cacheKey);

  // Se existir no cache e ainda não expirou
  if (cacheItem && Date.now() < cacheItem.expires) {
    return cacheItem.data;
  }

  try {
    const token = localStorage.getItem("token");

    // Monta headers condicionalmente
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    // Só adiciona o header thumb se for true
    if (thumb) {
      headers.thumb = true;
    }

    const res = await api.get(`/foto/${btoa(RM)}`, {
      responseType: "arraybuffer",
      headers,
    });

    const base64 = `data:image/jpeg;base64,${btoa(
      new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), "")
    )}`;

    // Cacheia com chave única
    imageCache.set(cacheKey, {
      data: base64,
      expires: Date.now() + CACHE_DURATION,
    });

    return base64;
  } catch (err) {
    console.error("Erro ao carregar imagem do aluno:", err);

    // Cacheia imagem padrão por 30 segundos (pra evitar spam de erro)
    imageCache.set(cacheKey, {
      data: UserDefault,
      expires: Date.now() + 30 * 1000,
    });

    return UserDefault;
  }
}
